import { render, staticRenderFns } from "./ManterProcurador.vue?vue&type=template&id=c7bd20b2&scoped=true&"
import script from "./ManterProcurador.vue?vue&type=script&lang=js&"
export * from "./ManterProcurador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bd20b2",
  null
  
)

export default component.exports